import React from 'react';
import './TermsModal.css'; // Importar los estilos

const TermsModal = ({ onAccept, onClose }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Términos y Condiciones de Uso de la Plataforma de Sorteos</h2>

                <section className="terms-section">
                    <h3>1. Aceptación de los Términos y Condiciones</h3>
                    <p>
                        Al acceder y utilizar la plataforma de sorteos, usted acepta y se compromete a cumplir con los presentes Términos y Condiciones. Estos términos constituyen un acuerdo legal entre usted y la plataforma (en adelante "la Plataforma"). Si no está de acuerdo con estos términos, no debe utilizar la Plataforma.
                    </p>

                    <h3>2. Requisitos para el Registro y Participación</h3>
                    <ul>
                        <li>El usuario debe ser mayor de edad conforme a la legislación vigente en su país de residencia (18 años en Colombia) para poder registrarse y participar en los sorteos.</li>
                        <li>El registro en la Plataforma se realiza mediante autenticación a través de la cuenta de Google del usuario. El uso de cualquier otra cuenta falsa o no autorizada conllevará la suspensión inmediata de la cuenta del usuario.</li>
                        <li>El usuario debe aceptar los términos de uso de los servicios de pago autorizados: <strong>Nequi</strong> y <strong>Daviplata</strong>.</li>
                    </ul>

                    <h3>3. Medios de Pago</h3>
                    <ul>
                        <li>El único medio de pago autorizado para recargar saldo y realizar retiros en la Plataforma será a través de <strong>Nequi</strong> y <strong>Daviplata</strong>. No se aceptan otros métodos de pago.</li>
                        <li>El monto mínimo para realizar una recarga en la cuenta de usuario es de <strong>10.000 COP</strong>.</li>
                        {/* <li>Para poder realizar retiros, el usuario debe acumular un saldo mínimo de <strong>100.000 COP</strong> en su cuenta.</li> */}
                    </ul>

                    <h3>4. Participación en Sorteos</h3>
                    <ul>
                        <li>El usuario podrá participar en sorteos seleccionando sus números o utilizando la función de números aleatorios.</li>
                        <li>La participación en los sorteos solo es válida si el saldo de la cuenta del usuario cubre el costo de los números seleccionados.</li>
                        <li>Una vez finalizado un sorteo, no se aceptarán reclamos por selección incorrecta de números o participación no registrada.</li>
                        <li>La Plataforma no garantiza ganancias, y la participación en sorteos se realiza bajo el entendimiento de que es un juego de azar.</li>
                    </ul>

                    <h3>5. Promociones y Fidelización</h3>
                    <ul>
                        <li>Las promociones disponibles serán analizadas y ofrecidas al usuario en función del desarrollo de los sorteos.</li>
                        <li>El sistema de <strong>fidelización</strong> se implementará en una fase posterior. La Plataforma se reserva el derecho de modificar los términos del sistema de fidelización cuando lo considere necesario.</li>
                    </ul>

                    <h3>6. Premios y Retiros</h3>
                    <ul>
                        <li>Los premios obtenidos en los sorteos serán transferidos a la cuenta de Nequi o Daviplata del usuario según la elección del participante, una vez se verifique su elegibilidad para recibirlos.</li>
                        <li>La Plataforma retendrá los impuestos que apliquen conforme a la legislación vigente, y el usuario será responsable de cumplir con sus obligaciones fiscales.</li>
                        <li>En caso de que el premio exceda los límites legales, se aplicarán las retenciones fiscales correspondientes.</li>
                    </ul>

                    <h3>7. Obligaciones y Responsabilidades del Usuario</h3>
                    <ul>
                        <li>El usuario es responsable de mantener la confidencialidad de sus credenciales de acceso y de todas las actividades que ocurran bajo su cuenta.</li>
                        <li>Está prohibido utilizar la Plataforma para fines ilegales, fraudulentos o que incumplan con las normativas de juego vigentes.</li>
                        <li>El usuario se compromete a proporcionar información veraz, completa y actualizada al registrarse y al usar los servicios de la Plataforma.</li>
                    </ul>

                    <h3>8. Cancelación de Cuentas</h3>
                    <ul>
                        <li>La Plataforma se reserva el derecho de suspender o cancelar cuentas de usuarios que incumplan con estos Términos y Condiciones, realicen fraudes, abusos o cualquier actividad que comprometa la seguridad y transparencia del sistema.</li>
                        <li>Cualquier saldo restante en la cuenta del usuario al momento de la suspensión o cancelación de su cuenta será devuelto en conformidad con las normativas aplicables y previa deducción de cualquier tarifa o impuesto correspondiente.</li>
                    </ul>

                    <h3>9. Responsabilidades de la Plataforma</h3>
                    <ul>
                        <li>La Plataforma se compromete a garantizar la equidad en la selección de los ganadores, mediante el uso de un sistema certificado de sorteos aleatorios.</li>
                        <li>La Plataforma no se responsabiliza por errores técnicos, interrupciones de servicio o problemas fuera de su control que puedan afectar la participación en los sorteos.</li>
                        <li>Los resultados de los sorteos son definitivos y no pueden ser impugnados.</li>
                    </ul>

                    <h3>10. Impuestos y Retenciones</h3>
                    <ul>
                        <li>Los premios estarán sujetos a las <strong>retenciones fiscales</strong> que correspondan de acuerdo con la legislación del país donde se desarrolle la Plataforma. El usuario es responsable de cumplir con las obligaciones fiscales asociadas a sus ganancias.</li>
                        <li>La Plataforma se reserva el derecho de retener los montos necesarios para cubrir los impuestos correspondientes antes de realizar el pago de cualquier premio.</li>
                    </ul>

                    <h3>11. Expansión Internacional</h3>
                    <ul>
                        <li>Si la Plataforma se expande a otras jurisdicciones fuera de Colombia, estos Términos y Condiciones pueden ser modificados para cumplir con las normativas legales y fiscales locales.</li>
                        <li>El usuario será notificado de cualquier cambio en los términos antes de su entrada en vigor.</li>
                    </ul>

                    <h3>12. Modificación de los Términos</h3>
                    <ul>
                        <li>La Plataforma se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. Cualquier cambio será notificado a los usuarios a través de los medios habituales de comunicación, y el uso continuado de la Plataforma después de la modificación se interpretará como una aceptación de los nuevos términos.</li>
                    </ul>

                    <h3>13. Ley Aplicable y Jurisdicción</h3>
                    <ul>
                        <li>Estos Términos y Condiciones se rigen por las leyes de Colombia. En caso de conflicto, las partes acuerdan someterse a la jurisdicción de los tribunales competentes en Colombia.</li>
                    </ul>
                </section>

                <div className="modal-actions">
                    <button className="accept-btn" onClick={onAccept}>
                        Acepto los Términos y Condiciones
                    </button>
                    <button className="close-btn" onClick={onClose}>
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TermsModal;
